/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SignInAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function SignInAction({
  children,
  viewPath = "/App/Auth/ResetPasswordConfirm/TwoFactorAuth/SignInAction",
  isSubmitting
  
}) {
let resetPasswordConfirmIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'reset_password_confirm',
})
let onClick = fromHelpers.useOnSubmit({
  children,
  viewPath,
  isSubmitting
  
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 size="large"
 data="reset_password_confirm"
 onClick={onClick}
 disabled={resetPasswordConfirmIsSubmittingData}
 marginLeft="auto"
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Verify and Sign in"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}